/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { OffersAccordionContainerEnhancedProps } from './OffersAccordionContainerEnhanced.types';
import { StyledOffersAccordionContainerEnhanced } from './OffersAccordionContainerEnhanced.styles';
import { lazy, Suspense, useEffect } from 'react';
import { constructJsonSchema } from '../../utils/generateJsonSchemaUtils';
export const OffersAccordionContainerWrapper: React.FC<OffersAccordionContainerEnhancedProps> = props => {
  const AccordionContainerEnhanced = lazy(() =>
    import('@marriott/mi-common-static-components').then(module => ({
      default: module.AccordionContainerEnhanced,
    }))
  );
  const { isAuthorMode, allowedComponents, model } = props;
  const items = (model?.cqItems || model?.[':items']) ?? {};
  const headerListItems = model?.headerListItems ?? [];

  //Code generate script for SEO
  const addJSONtoScript = (jsonLdData: any) => {
    // Check if the script already exists
    if (document.getElementById('FAQPage') === null) {
      // Select the target div
      const targetDiv = document.getElementById('offers-FAQsAccordion');

      // Ensure targetDiv is not null
      if (targetDiv) {
        // Create a new script element
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'FAQPage';
        script.textContent = JSON.stringify(jsonLdData); // Set the JSON-LD data directly

        // Insert the script after the target div
        targetDiv.insertAdjacentElement('afterend', script);
      } else {
        console.error('Target div not found.');
      }
    }
  };

  useEffect(() => {
    const jsonLdData = constructJsonSchema(headerListItems, items);
    addJSONtoScript(jsonLdData);
  }, []);

  return (
    <StyledOffersAccordionContainerEnhanced>
      <div data-testid="offers-OffersAccordionWrapper">
        <Suspense fallback={''}>
          <AccordionContainerEnhanced
            {...props}
            model={model}
            isAuthorMode={isAuthorMode}
            allowedComponents={allowedComponents}
          />
        </Suspense>
      </div>
    </StyledOffersAccordionContainerEnhanced>
  );
};
export default OffersAccordionContainerWrapper;
